module.exports = __webpack_public_path__ + "img/sensor_fault.bdc54903.svg";